import { useMemo } from 'react'
import {
  Deposit,
  DepositCondition,
  DepositPayable,
  FormCondition,
  FormConditionCondition,
} from '@urbanx/agx.campaigns.client'

export default function useDefaultDepositPayableValue(
  formCondition?: FormCondition | Deposit
): DepositPayable {
  return useMemo(() => {
    // If daysFromDate is set or AsPerContract condition, it's "N days from"
    if (
      formCondition?.daysFromDate !== undefined ||
      formCondition?.condition === FormConditionCondition.AsPerContract
    ) {
      return DepositPayable.NDaysFrom
    }

    // If OnSpecificDate condition, OnDate condition (deposit), or referenceDate is set, it's "on"
    if (
      formCondition?.condition === FormConditionCondition.OnSpecificDate ||
      formCondition?.condition === DepositCondition.OnDate ||
      formCondition?.referenceDate
    ) {
      return DepositPayable.On
    }

    // If depositPayable is explicitly set, use it
    if (formCondition?.depositPayable) {
      return formCondition.depositPayable as unknown as DepositPayable
    }

    return DepositPayable.NDaysFrom
  }, [formCondition])
}
